import angular = require("angular");

export function initialize(module: ng.IModule) {
    module.filter("searchFilter", searchFilter);
}

function searchFilter() {
    return function(items, searchText: string, filterByProperty: string) {
        var filtered = [];

        angular.forEach(items, function(item) {
            if (isPropertyDefined(item, filterByProperty) && matches(item, searchText, filterByProperty)) {
                filtered.push(item);
            }
        });

        return filtered;
    }
}

function isPropertyDefined(item, property: string) : boolean {
    return item[property];
}

function matches(item, searchText: string, filterByProperty: string) : boolean {
    // Lowercased equal comparison
    return (angular.lowercase(item[filterByProperty]).indexOf(angular.lowercase(searchText) || '') !== -1);
} 


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/search.filter.ts